import { RoutePaths } from './constants';

export const getRoute = (route: RoutePaths, id: string | number) => {
  return route.replace(`:id`, id.toString());
};
export const getRoute1 = (
  route: string,
  id: string | number,
  query?: Record<string, string | number>
) => {
  let path = route.replace(":id", id.toString());

  if (query) {
    path +=
      "?" +
      new URLSearchParams(
        Object.entries(query).reduce(
          (acc, [k, v]) => ({ ...acc, [k]: String(v) }),
          {}
        )
      ).toString();
  }

  return path;
};


export const reload = () => {
  window.location.reload();
};

export const noExtraSpaces = (_: any, value: string) => {
  if (!value) return Promise.resolve();

  // ❌ Leading or trailing spaces
  if (value.trim() !== value) {
    return Promise.reject("Name cannot start or end with spaces.");
  }

  // ❌ Multiple spaces inside name
  if (/\s{2,}/.test(value)) {
    return Promise.reject("Name cannot contain multiple spaces.");
  }

  return Promise.resolve();
};
export const capitalizeFirst = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();